import { render, staticRenderFns } from "./ReaderDetails.vue?vue&type=template&id=ac99fe34&scoped=true&"
import script from "./ReaderDetails.vue?vue&type=script&lang=js&"
export * from "./ReaderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReaderDetails.vue?vue&type=style&index=0&id=ac99fe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac99fe34",
  null
  
)

export default component.exports